import { STRING } from "../constants/string";

/**
 * /debug/ui-kit/form => ["debug", ["ui-kit", "form"]]
 */
export const decomposeUrl = (path: string): [string, string[]] => {
  const [lang, ...urls] = path.split(STRING.SLASH).filter(Boolean);
  const [langRemovedQuery] = (lang || STRING.EMPTY).split(/[?#]/);
  return [langRemovedQuery, urls];
};
